export default __webpack_public_path__ + "static/media/05B.030.d7b43605.png";